import { ENTER_KEY,
         BACKSPACE_KEY,
         DELETE_KEY,
         UP_KEY,
         DOWN_KEY } from "./constants/keys";

import { constantize } from "./format_helper";

MOVE.CONSTANTS = (function (MOVE) {

  var PRICE_FACET_PIVOT_VALUE = 1 / 4;
  var DEFAULT_MEDIAN_PRICE_FOR_SALE = 200000;
  var DEFAULT_MEDIAN_PRICE_FOR_RENT = 1111;
  var LOADING_ICON = '<span class="loading-graphic"></span>';
  var LOADING_ICON_CLASS = 'loading-graphic';
  var CACHED_USER_INPUT_STOREAGE_NAME = 'user_lead_inputs';
  var CACHED_USER_PROFILE_LEAD_INPUTS = 'user_profile_lead_inputs';
  var DEFAULT_LAZY_LOADING_IMG_OPTIONS = {
    visibleOnly: false,
    edgeY: 600,
    throttle: 100
  };
  var DEFAULT_ZOOM = 10;
  var DEFAULT_PIN_HEIGHT = 25;

  var IS_IPAD = navigator.userAgent.match(/iPad/i) !== null;

  var DEFAULT_LANDING_PAGE_LOCATION        = 'San Francisco, CA';
  var LANDING_PAGE_DEFAULT_CARD_SIZE       = '5';
  var DEFAULT_FACET_PAGE_TYPE              = 'srp-list';

  var LANDER_FS_NEW_LISTING_CARD           = 'fs_new_listing';
  var LANDER_FS_OPEN_HOUSE_CARD            = 'fs_open_house';
  var LANDER_FS_MEDIAN_HOMES_CARD          = 'fs_median_homes';
  var LANDER_FS_LUXURY_HOMES_CARD          = 'fs_luxury_homes';
  var LANDER_FS_AFFORD_HOMES_CARD          = 'fs_affordable_homes';
  var LANDER_FS_PRICE_REDUCED_CARD         = 'fs_pricereduced_homes';
  var LANDER_FS_FORECLOSURE_CARD           = 'fs_foreclosure_homes';
  var LANDER_FS_NEW_HOMES_CARD             = 'fs_new_homes';
  var LANDER_FS_NEW_CONSTRUCTION_CARD      = 'fs_new_construction';
  var LANDER_FR_PET_FRIENDLY_CARD          = 'fr_pet_friendly';
  var LANDER_FR_WITH_POOL_CARD             = 'fr_listings_with_pool';
  var LANDER_FR_WITH_LAUNDRY_CARD          = 'fr_listings_with_laundry';
  var LANDER_FR_RECREATION_FACILITIES_CARD = 'fr_recreation_facilities';
  var LANDER_FR_STUDIO_APARTMENTS_CARD     = 'fr_studio_apartments';
  var LANDER_FR_RENTAL_HOMES_CARD          = 'fr_rental_homes';
  var LANDER_RS_JUST_SOLD_CARD             = 'rs_just_sold_homes';
  var LANDER_RS_MEDIAN_HOMES_CARD          = 'rs_median_homes';
  var LANDER_RS_LUXURY_HOMES_CARD          = 'rs_luxury_homes';
  var LANDER_RS_AFFORD_HOMES_CARD          = 'rs_affordable_homes';
  var GET_NORESULTS_ZOOM                   =  2;

  var RDC_URL_STEMS = {
    LOCAL: 'local',
    MORTGAGE: 'mortgage'
  };

  var ALLOWED_SCHOOL_PAGETYPE = [
    'ldp',
    'landers_sale',
    'hp'
  ];

  var PROPERTY_STATUS = {
    forSale: 'for_sale',
    forRent: 'for_rent',
    recentlySold: 'recently_sold',
    propertyRecords: 'property_records',
    newCommunity: 'new_community',
    newPlan: 'new_plan',
    foreclosure: 'foreclosure'
  };

  var PROPERTY_TYPE_MAPPING = {
    'single-family-home': 'single_family',
    'condo-townhome-row-home-co-op': 'condo',
    'farms-ranches': 'farm',
    'land': 'land',
    'multi-family-home': 'multi_family'
  };


  var PROPERTY_SEARCH_STATUS = {
    'Search::PropertiesController': 'for_sale',
    'Search::NewCommunitiesController': 'new_home',
    'Search::RecentlySoldController': 'not_for_sale',
    'Search::NewConstructionController': 'for_sale',
    'Search::ForeclosuresController': 'for_sale',
    'Search::ApartmentsController': 'rental',
    'Search::HomesForRentController': 'rental'
  };

  var LDP_PROPERTY_TYPES = {
    new_community: 'new_home_community',
    new_plan: 'new_home_community'
  };

  var LDP_SUB_PROPERTY_TYPES = {
    new_community: '',
    new_plan: 'new_home_plan',
    for_rent: 'rental'
  };


  var LANDING_PAGE_SUB_DIRS = {
    forSale: 'realestateforsale',
    forRent: 'rentals'
  };


  // Please make sure to change this constant file whenever any changes are
  //made to the search controller names.
  var SEARCH_CONTROLLER_TYPE = {
    forSale: 'Search::PropertiesController',
    forRent: 'Search::ApartmentsController',
    recentlySold: 'Search::RecentlySoldController',
    propertyRecords: 'PropertyRecordsController',
    newCommunity: 'Search::NewCommunitiesController',
    newPlan: 'Search::NewConstructionController',
    foreclosure: 'Search::ForeclosuresController'
  };

  var ADVERTISER_FORM_NAME_MAPPING = {
    'Listing Agent': 'business_card',
    'Listing Broker': 'business_card',
    'office': 'listing_provider'
  };

  var ADVERTISER_TARGET_MAPPING = {
    'Listing Agent':  'seller_agent',
    'Listing Broker': 'seller_office',
    'office': 'seller_office'
  };

  var SRP_PAGINATION_MAX_PROPERTY_NUMBER = 9900;
  var PROP_TYPE_VALUE_TO_CRIT_MAPPING = {
      single_family: 'single-family-home',
      townhome: 'townhouse',
      condo: 'condo-townhome-row-home-co-op',
      mobile: 'mfd-mobile-home',
      farm: 'farms-ranches',
      land: 'land',
      multi_family: 'multi-family-home',
      apartments: 'apartments',
      others: 'others',
      condo_townhome: 'condo_townhome',
      coop: 'coop'
  };

  var PROP_TYPE_CRIT_TO_VALUE_MAPPING = {
        'single-family-home': 'single_family',
        'townhouse': 'townhome',
        'condo-townhome-row-home-co-op': 'condo',
        'mfd-mobile-home': 'mobile',
        'farms-ranches': 'farm',
        'land': 'land',
        'multi-family-home': 'multi_family',
        'apartments': 'apartments',
        'others': 'others',
        'condo_townhome': 'condo_townhome',
        'coop': 'coop'
  };

  MOVE.CONSTANTS =
  {
    LOADING_ICON: LOADING_ICON,
    LOADING_ICON_CLASS: LOADING_ICON_CLASS,
    IS_IPAD: IS_IPAD,
    DEFAULT_LAZY_LOADING_IMG_OPTIONS: DEFAULT_LAZY_LOADING_IMG_OPTIONS,
    PROPERTY_STATUS: PROPERTY_STATUS,
    PROPERTY_SEARCH_STATUS: PROPERTY_SEARCH_STATUS,
    LANDING_PAGE_SUB_DIRS: LANDING_PAGE_SUB_DIRS,
    LDP_PROPERTY_TYPES: LDP_PROPERTY_TYPES,
    SEARCH_CONTROLLER_TYPE: SEARCH_CONTROLLER_TYPE,
    PRICE_FACET_PIVOT_VALUE: PRICE_FACET_PIVOT_VALUE,
    DEFAULT_MEDIAN_PRICE_FOR_SALE: DEFAULT_MEDIAN_PRICE_FOR_SALE,
    DEFAULT_MEDIAN_PRICE_FOR_RENT: DEFAULT_MEDIAN_PRICE_FOR_RENT,
    DEFAULT_ZOOM: DEFAULT_ZOOM,
    DEFAULT_PIN_HEIGHT:DEFAULT_PIN_HEIGHT,
    LDP_SUB_PROPERTY_TYPES: LDP_SUB_PROPERTY_TYPES,
    RDC_URL_STEMS: RDC_URL_STEMS,
    PROPERTY_TYPE_MAPPING: PROPERTY_TYPE_MAPPING,
    CACHED_USER_INPUT_STOREAGE_NAME: CACHED_USER_INPUT_STOREAGE_NAME,
    CACHED_USER_PROFILE_LEAD_INPUTS: CACHED_USER_PROFILE_LEAD_INPUTS,
    ADVERTISER_FORM_NAME_MAPPING: ADVERTISER_FORM_NAME_MAPPING,
    ADVERTISER_TARGET_MAPPING: ADVERTISER_TARGET_MAPPING,
    DEFAULT_LANDING_PAGE_LOCATION: DEFAULT_LANDING_PAGE_LOCATION,
    LANDING_PAGE_DEFAULT_CARD_SIZE: LANDING_PAGE_DEFAULT_CARD_SIZE,
    DEFAULT_FACET_PAGE_TYPE: DEFAULT_FACET_PAGE_TYPE,
    LANDER_FS_NEW_LISTING_CARD: LANDER_FS_NEW_LISTING_CARD,
    LANDER_FS_OPEN_HOUSE_CARD: LANDER_FS_OPEN_HOUSE_CARD,
    LANDER_FS_NEW_HOMES_CARD: LANDER_FS_NEW_HOMES_CARD,
    LANDER_FS_MEDIAN_HOMES_CARD: LANDER_FS_MEDIAN_HOMES_CARD,
    LANDER_FS_LUXURY_HOMES_CARD: LANDER_FS_LUXURY_HOMES_CARD,
    LANDER_FS_AFFORD_HOMES_CARD: LANDER_FS_AFFORD_HOMES_CARD,
    LANDER_FR_PET_FRIENDLY_CARD: LANDER_FR_PET_FRIENDLY_CARD,
    LANDER_FR_WITH_POOL_CARD: LANDER_FR_WITH_POOL_CARD,
    LANDER_FR_WITH_LAUNDRY_CARD: LANDER_FR_WITH_LAUNDRY_CARD,
    LANDER_FR_RECREATION_FACILITIES_CARD: LANDER_FR_RECREATION_FACILITIES_CARD,
    LANDER_FR_STUDIO_APARTMENTS_CARD: LANDER_FR_STUDIO_APARTMENTS_CARD,
    LANDER_FR_RENTAL_HOMES_CARD: LANDER_FR_RENTAL_HOMES_CARD,
    LANDER_RS_JUST_SOLD_CARD:  LANDER_RS_JUST_SOLD_CARD,
    LANDER_RS_MEDIAN_HOMES_CARD: LANDER_RS_MEDIAN_HOMES_CARD,
    LANDER_RS_LUXURY_HOMES_CARD: LANDER_RS_LUXURY_HOMES_CARD,
    LANDER_RS_AFFORD_HOMES_CARD: LANDER_RS_AFFORD_HOMES_CARD,
    SRP_PAGINATION_MAX_PROPERTY_NUMBER: SRP_PAGINATION_MAX_PROPERTY_NUMBER,
    PROP_TYPE_CRIT_TO_VALUE_MAPPING: PROP_TYPE_CRIT_TO_VALUE_MAPPING,
    PROP_TYPE_VALUE_TO_CRIT_MAPPING: PROP_TYPE_VALUE_TO_CRIT_MAPPING,
    ENTER_KEY: ENTER_KEY,
    BACKSPACE_KEY: BACKSPACE_KEY,
    DELETE_KEY: DELETE_KEY,
    UP_KEY: UP_KEY,
    DOWN_KEY: DOWN_KEY,
    LANDER_FS_PRICE_REDUCED_CARD: LANDER_FS_PRICE_REDUCED_CARD,
    LANDER_FS_FORECLOSURE_CARD: LANDER_FS_FORECLOSURE_CARD,
    LANDER_FS_NEW_CONSTRUCTION_CARD: LANDER_FS_NEW_CONSTRUCTION_CARD,
    ALLOWED_SCHOOL_PAGETYPE: ALLOWED_SCHOOL_PAGETYPE,
    GET_NORESULTS_ZOOM: GET_NORESULTS_ZOOM

  };
  return constantize(MOVE.CONSTANTS);

})(MOVE || {});

export * from './constants/index';



// WEBPACK FOOTER //
// ./shared_critical/constants.js